import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag: (
      type: string,
      action: string,
      params: {
        page_path?: string;
        page_title?: string;
        page_location?: string;
        [key: string]: any;
      }
    ) => void;
    plausible: {
      (event: string, options?: { props?: Record<string, any> }): void;
      q?: any[];
    };
  }
}

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track pageview with Google Analytics
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname,
        page_title: document.title,
        page_location: window.location.href
      });
    }

    // Track pageview with Plausible
    if (typeof window.plausible !== 'undefined') {
      window.plausible('pageview', {
        props: {
          path: location.pathname,
          title: document.title,
          url: window.location.href
        }
      });
    }
  }, [location]);
};